import ApiServiceV1 from './v1'
import ApiServiceV2 from './v2'

export default ApiServiceV1
export {
  ApiServiceV1,
  ApiServiceV2,
}
